import { useEffect } from "react";

// Per-page document title + meta description (SPA needs this set client-side).
export function useSeo({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
  }, [title, description]);
}
